<template>
  <v-app id="app">
    <div class="menu-button" @click="clickMenu()" />
    <router-view />
    <Footer />
    <Menu ref="menu" />
  </v-app>
</template>

<script>
import Footer from './components/Footer.vue';
import Menu from '@/components/Menu';

export default {
  name: 'App',
  components: {
    Footer,
    Menu
  },
  computed: {
    isScreenSmAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    clickMenu() {
      this.$refs.menu.open();
    }
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

a {
  text-decoration: none;
}

.menu-button {
  background-image: url('./assets/img/menubutton_sp.png');
  background-position: center;
  background-size: contain;
  position: absolute;
  width: 50px;
  height: 50px;
  top: 16px;
  right: 16px;
  position: fixed;
  z-index: 1000;
  cursor: pointer;

  @media screen and (min-width: 960px) {
    width: 88px;
    height: 88px;
    top: 24px;
    right: 24px;
  }
}
</style>
